export const DOMAIN = process.env.VUE_APP_BASE_API;

export const API = {
    AUTH: {
        LOGIN: '/user/api/v1/login',
        REGISTER: '/api/v1/register',
        REFRESH: '/user/api/v1/fresh'
    },
    BANNER: {
        LIST: '/banner/api/v1/list',
        DETAIL: `/banner/api/v1/details`,
        CREATE: '/banner/api/v1/create',
        UPDATE: '/banner/api/v1/update',
        DELETE: '/banner/api/v1/delete'
    },
    LAYOUT: {
        LIST: '/layout/api/v1/layout',
        CREATE: '/layout/api/v1/layout/create',
        DELETE: '/layout/api/v1/layout/delete',
        BACKUP: '/layout/api/v1/layout/backup',
        RESET: '/layout/api/v1/layout/reset',
        DETAIL: '/layout/api/v1/layout/details',
        UPDATE: '/layout/api/v1/layout/update',
        MODULE: '/layout/api/v1/mod/list',
        THEME: '/layout/api/v1/arrangement',
        PARTIAL: '/layout/api/v1/list/partial'
    },
    PERMISSION: {
        GET_LIST: '/permission/api/v1/permissions'
    },
    PERMISSION_GROUP: {
        GET_LIST: '/permission/api/v1/permission_group/list',
        DETAIL: '/permission/api/v1/permission_group/detail',
        CREATE: '/permission/api/v1/permission_group/create',
        UPDATE: '/permission/api/v1/permission_group/update',
        DELETE: '/permission/api/v1/permission_group/delete',
    },
    USER: {
        LIST: '/user/api/v1/list',
        DETAIL: '/user/api/v1/detail',
        CREATE: '/user/api/v1/create',
        DELETE: '/user/api/v1/delete',
        UPDATE: '/user/api/v1/update',
        FORGET: '/user/api/v1/forget',
        UPDATE_PROFILE: '/user/api/v1/update/profile',
        RESET_PASSWORD: '/user/api/v1/reset-password',
        UPDATE_PASSWORD: '/user/api/v1/update-password',
    },
    CATEGORY: {
        LIST: '/category/api/v1/list',
        UPDATE: '/category/api/v1/update',
        DELETE: '/category/api/v1/delete',
        CREATE: '/category/api/v1/create',
        DETAIL: '/category/api/v1/details',
    },
    IMAGE: {
        UPLOAD: '/image/api/v1/upload',
        FILE: '/file/api/v1/upload'
    },
    PRODUCT: {
        LIST: '/product/api/v1/list',
        REVIEW: '/product/api/v1/review',
        SEARCH: '/product/api/v1/search',
        DELETE: '/product/api/v1/delete',
        CREATE: '/product/api/v1/create',
        DETAIL: '/product/api/v1/detail',
        UPDATE: '/product/api/v1/update',
        UPLOAD_IMG: '/product/api/v1/upload',
        UPLOAD_VIDEO: '/product/api/v1/uploadvideo',
        VARIATIONS: '/product/api/v1/variations',
        LIST_VARIATIONS: '/product/api/v1/list/variation',
        GET_WAREHOUSES: '/product/api/v1/warehouse/list',
        UPDATE_SELLABLE: '/product/api/v1/sellable/update',
        PRODUCT_FILTER: '/product-statistical/api/v1/filter',
        UPDATE_WAREHOUSES: '/product/api/v1/update/quantity',
        SEARCH_VARIATIONS: '/product/api/v1/variation/search',
        UPDATE_ENABLE: '/product/api/v1/enable',
        CHECK_SKU: '/product/api/v1/check_skus'
    },
    ATTRIBUTE: {
        LIST: '/attr/api/v1/list',
        CREATE: '/attr/api/v1/create',
        DELETE: '/attr/api/v1/delete',
        DETAIL: '/attr/api/v1/detail',
        UPDATE: '/attr/api/v1/update',
        LIST_SUB: '/attr/api/v1/list/sub',
    },
    WAREHOUSE: {
        LIST: '/warehouse/api/v1/list',
        DELETE: '/warehouse/api/v1/delete',
        CREATE: '/warehouse/api/v1/create',
        UPDATE: '/warehouse/api/v1/update'
    },
    BLOG: {
        LIST: '/blog/api/v1/list',
        UPDATE: '/blog/api/v1/update',
        DELETE: '/blog/api/v1/delete',
        CREATE: '/blog/api/v1/create',
        DETAIL: "/blog/api/v1/details",
    },
    EXTRA: {
        LIST: '/extra/api/v1/list',
        UPDATE: '/extra/api/v1/update',
        DELETE: '/extra/api/v1/delete',
        CREATE: '/extra/api/v1/create',
        DETAIL: "/extra/api/v1/details",
        LISTPARENT: '/extra/api/v1/list/parent',
    },
    MENU: {
        LIST: '/menu/api/v1/list',
        UPDATE: '/menu/api/v1/update',
        DELETE: '/menu/api/v1/delete',
        CREATE: '/menu/api/v1/create',
        DETAIL: (id: string) => `/menu/api/v1/detail/${id}`,
    },
    FUNCTION: {
        GET_LIST_BY_ID: `/layout/api/v1/func/list`
    },
    COUNTRY: {
        PROVINCE: '/country/api/v1/province',
        DISTRICT: '/country/api/v1/district',
        COMMUNE: '/country/api/v1/commune'
    },
    COLLECTION: {
        LIST: '/collection/api/v1/list',
        DELETE: '/collection/api/v1/delete',
        CREATE: '/collection/api/v1/create',
        UPDATE: '/collection/api/v1/update',
        DETAIL: '/collection/api/v1/detail',
        DISPLAY_LIST: '/collection/api/v1/display_list',
        UPDATE_DISPLAY_LIST: '/collection/api/v1/update_display_list',
    },
    FILE: {
        CREATE: '/file/api/v1/uploadimage',
        LIST: '/file/api/v1/listimage',
    },
    BLOCK: {
        CREATE: '/block/api/v1/create',
        LIST: '/block/api/v1/list',
        UPDATE: '/block/api/v1/update',
        DETAIL: `/block/api/v1/details`,
        DELETE: '/block/api/v1/delete',
    },
    TAG: {
        LIST: '/tag/api/v1/list',
        DELETE: '/tag/api/v1/delete',
        CREATE: '/tag/api/v1/create',
        UPDATE: '/tag/api/v1/update',
        DETAIL: '/tag/api/v1/detail',
        CONFIG_LIST: '/config/api/v1/list',
        CONFIG_DETAIL: '/config/api/v1/detail_tag',
        CONFIG_UPDATE: '/config/api/v1/update'
    },
    FLASHSALE: {
        LIST: '/flashsale/api/v1/list',
        FILTER: '/flashsale/api/v1/filter',
        DELETE: '/flashsale/api/v1/delete',
        CREATE: '/flashsale/api/v1/create',
        UPDATE: '/flashsale/api/v1/update',
        DETAIL: '/flashsale/api/v1/details',
        SALE_DATE: '/flashsale/api/v1/get-last-sale-date'
    },
    VOUCHER: {
        LIST: '/voucher/api/v1/list',
        DELETE: '/voucher/api/v1/delete',
        CREATE: '/voucher/api/v1/create',
        UPDATE: '/voucher/api/v1/update',
        DETAIL: '/voucher/api/v1/detail',
        UPDATE_STATUS: '/voucher/api/v1/update_status',
    },
    SOCIAL: {
        LIST: '/socials/api/v1/list',
        DELETE: '/socials/api/v1/delete',
        CREATE: '/socials/api/v1/create',
        UPDATE: '/socials/api/v1/update',
        DETAIL: '/socials/api/v1/detail',
    },
    ADV: {
        LIST: '/advertisement/api/v1/list',
        DELETE: '/advertisement/api/v1/delete',
        CREATE: '/advertisement/api/v1/create',
        UPDATE: '/advertisement/api/v1/update',
        DETAIL: '/advertisement/api/v1/detail',
    },
    CUSTOMER: {
        LIST: '/customer/api/v1/list',
        DELETE: '/customer/api/v1/delete',
        CREATE: '/customer/api/v1/create',
        UPDATE: '/customer/api/v1/update',
        DETAIL: '/customer/api/v1/detail',
        SEARCH: '/customer/api/v1/search',
        CREATE_ADDRESS: '/customer/api/v1/address-create',
        UPDATE_ADDRESS: '/customer/api/v1/address-update',
        DELETE_ADDRESS: '/customer/api/v1/address-delete',
    },
    CANCEL_REASON: {
        LIST: '/cancel_reason/api/v1/list',
        DELETE: '/cancel_reason/api/v1/delete',
        CREATE: '/cancel_reason/api/v1/create',
        UPDATE: '/cancel_reason/api/v1/update',
        DETAIL: '/cancel_reason/api/v1/detail',
        CHANGE_STATUS: '/cancel_reason/api/v1/change_status',
        UPDATE_POSITION: '/cancel_reason/api/v1/update-position',
    },
    TAG_REVIEW: {
        LIST: '/tag_review/api/v1/list',
        DELETE: '/tag_review/api/v1/delete',
        CREATE: '/tag_review/api/v1/create',
        UPDATE: '/tag_review/api/v1/update',
        DETAIL: '/tag_review/api/v1/detail',
        CHANGE_STATUS: '/tag_review/api/v1/change_status'
    },
    PROMOTION: {
        LIST: '/promotion/api/v1/list',
        CREATE: '/promotion/api/v1/create',
        DELETE: '/promotion/api/v1/delete',
        DETAIL: '/promotion/api/v1/detail',
        UPDATE: '/promotion/api/v1/update',
    },
    SLIDER: {
        CREATE: '/slider/api/v1/create',
        LIST: '/slider/api/v1/list',
        UPDATE: '/slider/api/v1/update',
        DETAIL: `/slider/api/v1/detail`,
        DELETE: '/slider/api/v1/delete',
    },
    GIFT: {
        CREATE: '/gift/api/v1/create',
        LIST: '/gift/api/v1/list',
        UPDATE: '/gift/api/v1/update',
        DETAIL: `/gift/api/v1/detail`,
        DELETE: '/gift/api/v1/delete',
        UPDATE_ENABLE: '/gift/api/v1/enable'
    },
    FILTER: {
        CREATE: '/filter/api/v1/create',
        LIST: '/filter/api/v1/list',
        UPDATE: '/filter/api/v1/update',
        DETAIL: `/filter/api/v1/detail`,
        DELETE: '/filter/api/v1/delete',
    },
    MODEL: {
        CREATE: '/model/api/v1/create',
        LIST: '/model/api/v1/list',
        UPDATE: '/model/api/v1/update',
        DETAIL: `/model/api/v1/detail`,
        DELETE: '/model/api/v1/delete',
    },
    SETTING: {
        GENARAL: '/settings/api/v1/genaral',
        UPDATE: '/settings/api/v1/update',
        STORE_LIST: '/settings/api/v1/list/store',
        STORE_CREATE: '/settings/api/v1/create/store',
        STORE_UPDATE: '/settings/api/v1/update/store',
        STORE_DELETE: '/settings/api/v1/delete/store',
        STORE_DETAIL: '/settings/api/v1/detail/store',
        SMS_LIST: '/sms/api/v1/list',
        SMS_UPDATE: '/sms/api/v1/update',
        CONFIGSIZE_CREATE: '/size/api/v1/create',
        CONFIGSIZE_LIST: '/size/api/v1/list',
        CONFIGSIZE_UPDATE: '/size/api/v1/update',
        CONFIGSIZE_DETAIL: `/size/api/v1/detail`,
        CONFIGSIZE_DELETE: '/size/api/v1/delete',
        CONFIGSIZE_DEFAULT: '/size/api/v1/default',
        SHIPPING_LIST: "/settings/shipping/api/v1/list",
        SHIPPING_CREATE: '/settings/shipping/api/v1/create',
        SHIPPING_UPDATE: '/settings/shipping/api/v1/update',
        SHIPPING_DETAIL: `/settings/shipping/api/v1/detail`,
        SHIPPING_DELETE: '/settings/shipping/api/v1/delete',
        SHIPPING_RATE_LIST: "/settings/shipping-rates/api/v1/list",
        SHIPPING_RATE_CREATE: '/settings/shipping-rates/api/v1/create',
        SHIPPING_RATE_UPDATE: '/settings/shipping-rates/api/v1/update',
        SHIPPING_RATE_DETAIL: `/settings/shipping-rates/api/v1/detail`,
        SHIPPING_RATE_DELETE: '/settings/shipping-rates/api/v1/delete',
        SHIPPING_CARRIER_LIST: "/settings/shipping-carriers/api/v1/list",
        SHIPPING_CARRIER_CREATE: '/settings/shipping-carriers/api/v1/create',
        SHIPPING_CARRIER_UPDATE: '/settings/shipping-carriers/api/v1/update',
        SHIPPING_CARRIER_DETAIL: `/settings/shipping-carriers/api/v1/detail`,
        SHIPPING_CARRIER_DELETE: '/settings/shipping-carriers/api/v1/delete',
        PAYMENT_CREATE: '/payments/api/v1/create',
        PAYMENT_LIST: '/payments/api/v1/list',
        PAYMENT_UPDATE: '/payments/api/v1/update',
        PAYMENT_DETAIL: `/payments/api/v1/detail`,
        PAYMENT_DELETE: '/payments/api/v1/delete',
        WEBSITE_DETAIL: '/settings/api/v1/detail/website',
        WEBSITE_UPDATE: '/settings/api/v1/update/website',
        WAREHOUSE_LIST: '/warehouse/api/v1/list',
        WAREHOUSE_CREATE: '/warehouse/api/v1/create',
        WAREHOUSE_UPDATE: '/warehouse/api/v1/update',
        WAREHOUSE_DELETE: '/warehouse/api/v1/delete',
    },
    COMMUNITY: {
        LIST_REVIEW: '/community/api/v1/list-review',
        LIST_COMMENT: '/community/api/v1/list-comment',
        ENABLE: '/community/api/v1/enable',
        NEW_FEED: '/community/api/v1/new-feed',
        TO_HOMEPAGE: '/community/api/v1/home/enable',
        GET_TOTAL: '/community/api/v1/get-total',
        LIST_CONFIG: '/community/api/v1/list-config',
        UPDATE_CONFIG: '/config/api/v1/update'
    },
    PUBLIC_FILE: {
        LIST: '/file/api/v1/listimage',
        UPLOAD: '/file/api/v1/uploadimage',
        DELETE: '/file/api/v1/delete'
    }
}